import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../config/api-client";
import { API_ENDPOINTS } from "../config/api-endpoints";
import { QueryKeys } from "../config/query-keys";
import type { PricingResponse } from "../models/api-types";

// Hook for pricing plans endpoint
export const usePricing = (queryOptions = {}) => {
  return useQuery({
    queryKey: QueryKeys.PRICING.plans(),
    queryFn: async (): Promise<PricingResponse> => {
      return await apiClient.get<PricingResponse>(
        `${API_ENDPOINTS.getAllPricing}?limit=20`
      );
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...queryOptions,
  });
};

// Hook for specific plan type (recurring or topup)
export const usePricingByType = (
  planType: "recurring" | "topup",
  queryOptions = {}
) => {
  return useQuery({
    queryKey: QueryKeys.PRICING.byType(planType),
    queryFn: async (): Promise<PricingResponse> => {
      const response = await apiClient.get<PricingResponse>(
        `${API_ENDPOINTS.getAllPricing}?limit=20`
      );
      // Filter by plan type
      const filteredData = {
        ...response,
        data: {
          ...response.data,
          result: response.data.result.filter(
            (plan) => plan.planType === planType
          ),
        },
      };
      return filteredData;
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...queryOptions,
  });
};
